import { Box, Modal, Grid } from "@mui/material";
import React from "react";
interface UserModalProps {
  open: boolean;
  isEdit?: boolean;
  onClose?: () => void;
  onSubmit?: () => void;
  user?: any;
  setUser?: any;
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
  width: "100%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "10px",
};
const UserModal = ({
  open,
  onClose,
  isEdit = false,
  onSubmit,
  user,
  setUser,
}: UserModalProps) => {
  const changeHandler = (e: any) => {
    const name = e?.target?.name;
    const value = e?.target?.value;
    const regPhone = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\./0-9]*$/;
    if (name === "phone") {
      if(value && regPhone.test(value)){
      setUser((pre: any) => ({
        ...pre,
        [name]: value,
      }));
      }
    } else {
      setUser((pre: any) => ({
        ...pre,
        [name]: value,
      }));
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <div className={"text-2xl font-bold"}>
          {isEdit ? "Update" : "Create"} User Modal
        </div>
        <form
          onSubmit={() => {
            if (onSubmit && onClose) {
              onSubmit();
              onClose();
            }
          }}
          className={"flex flex-col gap-4"}
        >
          <Grid container spacing={2} className={"overflow-auto max-h-[600px]"}>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"firstname"}
                  className={"text-sm font-semibold"}
                >
                  First Name
                </label>
                <input
                  id={"firstname"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"firstname"}
                  value={user?.firstname}
                  onChange={changeHandler}
                  required={!isEdit}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"middlename"}
                  className={"text-sm font-semibold"}
                >
                  Middle Name
                </label>
                <input
                  id={"middlename"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"middlename"}
                  value={user?.middlename}
                  onChange={changeHandler}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"lastname"} className={"text-sm font-semibold"}>
                  Last Name
                </label>
                <input
                  id={"lastname"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"lastname"}
                  value={user?.lastname}
                  onChange={changeHandler}
                  required={!isEdit}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"email"} className={"text-sm font-semibold"}>
                  Email
                </label>
                <input
                  id={"email"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"email"}
                  value={user?.email}
                  onChange={changeHandler}
                  type={"text"}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"phone"} className={"text-sm font-semibold"}>
                  Phone
                </label>
                <input
                  id={"phone"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"phone"}
                  value={user?.phone}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            {isEdit ? null : (
              <Grid item xs={12} sm={6} md={4}>
                <div className={"w-full flex flex-col items-start"}>
                  <label htmlFor={"ipin"} className={"text-sm font-semibold"}>
                    Ipin
                  </label>
                  <input
                    id={"ipin"}
                    className={
                      "bg-white w-full rounded-md p-2 border border-gray outline-none"
                    }
                    type={"number"}
                    name={"ipin"}
                    value={user?.ipin}
                    onChange={changeHandler}
                    required={!isEdit}
                  />
                </div>
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"userreferenceid"}
                  className={"text-sm font-semibold"}
                >
                  User Reference Id
                </label>
                <input
                  id={"userreferenceid"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"userreferenceid"}
                  value={user?.userreferenceid}
                  onChange={changeHandler}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"dob"} className={"text-sm font-semibold"}>
                  Date Of Birth
                </label>
                <input
                  id={"dob"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"date"}
                  name={"dob"}
                  value={user?.dob}
                  onChange={changeHandler}
                  required
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"gender"} className={"text-sm font-semibold"}>
                  Gender
                </label>
                <select
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  name={"gender"}
                  value={user?.gender}
                  onChange={changeHandler}
                  required={!isEdit}
                >
                  <option value={"Male"}>Male</option>
                  <option value={"Female"}>Female</option>
                  <option value={"Other"}>Other</option>
                </select>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"zip"} className={"text-sm font-semibold"}>
                  Zip
                </label>
                <input
                  id={"zip"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"zip"}
                  value={user?.zip}
                  onChange={changeHandler}
                  required={!isEdit}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"city"} className={"text-sm font-semibold"}>
                  City
                </label>
                <input
                  id={"city"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"city"}
                  value={user?.city}
                  onChange={changeHandler}
                  required={!isEdit}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label htmlFor={"state"} className={"text-sm font-semibold"}>
                  State
                </label>
                <input
                  id={"state"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"state"}
                  value={user?.state}
                  onChange={changeHandler}
                  required={!isEdit}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"refferalcode"}
                  className={"text-sm font-semibold"}
                >
                  Referral Code
                </label>
                <input
                  id={"refferalcode"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"refferalcode"}
                  value={user?.refferalcode}
                  onChange={changeHandler}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"userreferrallink"}
                  className={"text-sm font-semibold"}
                >
                  User Referral Link
                </label>
                <input
                  id={"userreferrallink"}
                  className={
                    "bg-white w-full rounded-md p-2 border border-gray outline-none"
                  }
                  type={"text"}
                  name={"userreferrallink"}
                  value={user?.userreferrallink}
                  onChange={changeHandler}
                />
              </div>
            </Grid>
            {/*{!isEdit ? <>*/}
            {/*  <Grid item xs={12} sm={6} md={4}>*/}
            {/*    <div className={"w-full flex flex-col items-start"}>*/}
            {/*      <label*/}
            {/*          htmlFor={"registered"}*/}
            {/*          className={"text-sm font-semibold"}*/}
            {/*      >*/}
            {/*        Registered*/}
            {/*      </label>*/}
            {/*      <input*/}
            {/*          id={"registered"}*/}
            {/*          className={*/}
            {/*            "bg-white w-full rounded-md p-2 border border-gray outline-none"*/}
            {/*          }*/}
            {/*          type={"date"}*/}
            {/*          name={"registered"}*/}
            {/*          value={user?.registered}*/}
            {/*          onChange={changeHandler}*/}
            {/*          required*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </Grid>*/}
            {/*  <Grid item xs={12} sm={6} md={4}>*/}
            {/*    <div className={"w-full flex flex-col items-start"}>*/}
            {/*      <label*/}
            {/*        htmlFor={"license_number"}*/}
            {/*        className={"text-sm font-semibold"}*/}
            {/*      >*/}
            {/*        License Number*/}
            {/*      </label>*/}
            {/*      <input*/}
            {/*        id={"license_number"}*/}
            {/*        className={*/}
            {/*          "bg-white w-full rounded-md p-2 border border-gray outline-none"*/}
            {/*        }*/}
            {/*        type={"text"}*/}
            {/*        name={"license_number"}*/}
            {/*        value={user?.license_number}*/}
            {/*        onChange={changeHandler}*/}
            {/*        required*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </Grid>*/}
            {/*  <Grid item xs={12} sm={6} md={4}>*/}
            {/*    <div className={"w-full flex flex-col items-start"}>*/}
            {/*      <label*/}
            {/*        htmlFor={"license_address"}*/}
            {/*        className={"text-sm font-semibold"}*/}
            {/*      >*/}
            {/*        License Address*/}
            {/*      </label>*/}
            {/*      <input*/}
            {/*        id={"license_address"}*/}
            {/*        className={*/}
            {/*          "bg-white w-full rounded-md p-2 border border-gray outline-none"*/}
            {/*        }*/}
            {/*        type={"text"}*/}
            {/*        name={"license_address"}*/}
            {/*        value={user?.license_address}*/}
            {/*        onChange={changeHandler}*/}
            {/*        required*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </Grid>*/}
            {/*  <Grid item xs={12} sm={6} md={4}>*/}
            {/*    <div className={"w-full flex flex-col items-start"}>*/}
            {/*      <label*/}
            {/*        htmlFor={"license_issue_date"}*/}
            {/*        className={"text-sm font-semibold"}*/}
            {/*      >*/}
            {/*        License Issue Date*/}
            {/*      </label>*/}
            {/*      <input*/}
            {/*        id={"license_issue_date"}*/}
            {/*        className={*/}
            {/*          "bg-white w-full rounded-md p-2 border border-gray outline-none"*/}
            {/*        }*/}
            {/*        type={"date"}*/}
            {/*        name={"license_issue_date"}*/}
            {/*        value={user?.license_issue_date}*/}
            {/*        onChange={changeHandler}*/}
            {/*        required*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </Grid>*/}
            {/*  <Grid item xs={12} sm={6} md={4}>*/}
            {/*    <div className={"w-full flex flex-col items-start"}>*/}
            {/*      <label*/}
            {/*        htmlFor={"license_expiry_date"}*/}
            {/*        className={"text-sm font-semibold"}*/}
            {/*      >*/}
            {/*        License Expiry Date*/}
            {/*      </label>*/}
            {/*      <input*/}
            {/*        id={"license_expiry_date"}*/}
            {/*        className={*/}
            {/*          "bg-white w-full rounded-md p-2 border border-gray outline-none"*/}
            {/*        }*/}
            {/*        type={"date"}*/}
            {/*        name={"license_expiry_date"}*/}
            {/*        value={user?.license_expiry_date}*/}
            {/*        onChange={changeHandler}*/}
            {/*        required*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </Grid>*/}
            {/*  <Grid item xs={12} sm={6} md={4}>*/}
            {/*    <div className={"w-full flex flex-col items-start"}>*/}
            {/*      <label htmlFor={"old_id"} className={"text-sm font-semibold"}>*/}
            {/*        Old Id*/}
            {/*      </label>*/}
            {/*      <input*/}
            {/*        id={"old_id"}*/}
            {/*        className={*/}
            {/*          "bg-white w-full rounded-md p-2 border border-gray outline-none"*/}
            {/*        }*/}
            {/*        type={"number"}*/}
            {/*        name={"old_id"}*/}
            {/*        value={user?.old_id}*/}
            {/*        onChange={changeHandler}*/}
            {/*        required*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*  </Grid>*/}
            {/*</> : null}*/}
          </Grid>
          <button
            className={
              "bg-primary text-white p-3 rounded-2xl disabled:cursor-not-allowed w-full"
            }
            type={"submit"}
          >
            {isEdit ? "Update" : "Create"}
          </button>
        </form>
      </Box>
    </Modal>
  );
};
export default UserModal;
